module.exports = __webpack_public_path__ + "img/float3.9f1f2e91.png";